export const compareArrays = (arr1, arr2) => {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    return arr1 === arr2
  }
  return (
    JSON.stringify(arr1.slice().sort()) === JSON.stringify(arr2.slice().sort())
  )
}

export const compareArraysByKey = (arr1, arr2, key) => {
  return compareArrays(
    arr1.map((item) => item[key]),
    arr2.map((item) => item[key])
  )
}
